import Cookies from 'js-cookie';
import ConfigCmsApi from '../configs/ConfigCmsApi';

const headers = () => ({ Authorization: Cookies.get('adminToken') });

const getClinicPrices = (clinicId, params = {}) => ConfigCmsApi.get(
  `/prices/clinic/${clinicId}`,
  { params, headers: headers() },
);

const upsert = (prices) => ConfigCmsApi.post(
  '/prices/',
  { prices },
  { headers: headers() },
);

export default { getClinicPrices, upsert };
